import { useGetUserDetailsByEmail } from '@forwardflow/hooks/customHooks/organization/useGetUserDetailsByEmail'
import { UserService } from '@forwardflow/services/UserService'
import { message } from 'antd'
import { useState, useEffect } from 'react'
import { useAppStore } from '@forwardflow/store'

const ROLES = ['Admin', 'Agent']

export const UserAccessPermission = ({
   email,
   userId,
}: {
   email: string
   userId: string
}) => {
   const { currentOrganization } = useAppStore()
   const { data: userDetails, isLoading, mutate } = useGetUserDetailsByEmail(
      email || ''
   )

   const [selectedRole, setSelectedRole] = useState<string | null>(null)
   const [loading, setLoading] = useState(false)

   // Initialize selected role when userDetails loads
   useEffect(() => {
      if (userDetails?.roles?.length) {
         setSelectedRole(userDetails.roles[0])
      }
   }, [userDetails?.roles])

   const handleRoleChange = async (role: string) => {
      if (role === selectedRole) return
      setLoading(true)
      try {
         await UserService.setUserAccessRole(
            currentOrganization as string,
            userId,
            [role]
         )

         setSelectedRole(role)
         mutate()
         message.success('User role updated successfully')
      } catch (e) {
         console.error('Failed to set user access role', e)
         message.error('Failed to update user role')
      } finally {
         setLoading(false)
      }
   }

   return (
      <div className="flex items-center justify-between px-5 py-3 rounded-md bg-primary/10">
            <span className="text-[13px] text-white/70">
               User Role
            </span>
            <div className="flex space-x-1">
               {ROLES.map((role) => (
                  <button
                     key={role}
                     disabled={loading || isLoading}
                     onClick={() => handleRoleChange(role)}
                     className={`px-5 py-1 rounded-sm border transition-colors text-sm font-semibold
                ${
                   selectedRole === role
                      ? 'bg-[#0FF04E]/20 text-white border-green-600'
                      : 'bg-black/10 text-gray-300 border-transparent hover:bg-black/20'
                }
                ${loading || isLoading ? 'cursor-not-allowed opacity-50' : ''}
              `}
                  >
                     {role}
                  </button>
               ))}
            </div>
      </div>
   )
}
